<template>
  <div class="wrc-login" :style="getBgImg()">
    <div class="title">
      <!-- 比赛主标题 -->
      <img class="logo" src="https://c.icode.org.cn/contests/wrc/wrc_icode_logo_2025.png" />
      <!-- <h1>2024世界机器人大赛</h1> -->

      <!-- 活动主标题 -->
      <h1 v-html="eventInfo.eventTitle"></h1>
      <!-- 活动副标题 -->
      <!-- <h2 v-html="eventInfo.subTitle"></h2> -->
    </div>
    <!-- 登录提示 -->
    <h1 v-if="eventInfo.id == null" class="loginTitle">即将开放，尽情期待</h1>

    <h1 v-if="eventInfo.id && loginStep==1" class="loginTitle">登录 ICode 账号</h1>
    <!-- 登录表单区域 -->
    <div v-if="eventInfo.id && loginStep==1"
      class="loginArea"
      v-loading="loading"
      element-loading-text="登录中，请稍候..."
    >
      <div class="userInput">
        <el-form
          ref="userForm"
          :rules="loginRules"
          :model="userForm"
          label-width="80px"
        >
          <el-form-item label="账号：" prop="name">
            <el-input 
              v-model="userForm.name"
              placeholder="请输入账号或手机号"
              width="80%"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="密码：" prop="password"  width="80%">
            <el-input
              v-model="userForm.password"
              placeholder="请输入密码"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="forgetPwd">
          <a @click="tofogot()">忘记密码？</a>
        </div>
      </div>
      <!-- 登录和报名按钮 -->
      <div class="btnlist">
        <button v-if="eventInfo.signUpBtn" class="up" @click="toSignup">注册</button>
        <button class="up" @click="login('userForm')">登录</button>
      </div>
    </div>

    <h2 v-if="loginStep==2" class="loginTitle">请输入报名时预留的身份证件确认您的报名信息</h2>
    <div v-if="loginStep==2" 
      class="loginArea"
      v-loading="loading"
      element-loading-text="校验中，请稍候..."
    >
      <div class="userInput">
        <el-form
          ref="userForm"
          :rules="identityRules"
          :model="userForm"
          label-width="100px"
        >
          <el-form-item label="证件信息" prop="identity">
            <el-input
              v-model="userForm.identity"
              placeholder="身份证号/护照"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="forgetPwd">
        <a @click="loginStep = 3">使用报名编号验证</a>
      </div>
        
      <!-- 文字模式 -->
      <div class="btnlist">
        <button class="up" @click="wrc_identity('userForm')">确认信息</button>
      </div>
    </div>

    <h2 v-if="loginStep==3" class="loginTitle">请输入您的报名编号和姓名来确认您的参赛信息</h2>
    <div v-if="loginStep==3" 
      class="loginArea"
      v-loading="loading"
      element-loading-text="校验中，请稍候..."
    >
      <div class="userInput">
        <el-form
          ref="userForm"
          :rules="identityRules"
          :model="userForm"
          label-width="100px"
        >
          <el-form-item label="报名编号" prop="wrcId">
            <el-input
              v-model.trim="userForm.wrcId"
              placeholder="报名编号，如30241"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="选手姓名" prop="userName">
            <el-input
              v-model.trim="userForm.userName"
              placeholder="参赛选手姓名"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="forgetPwd">
        <a @click="loginStep = 2">使用身份证件验证</a>
      </div>
        
      <!-- 文字模式 -->
      <div class="btnlist">
        <button class="up" @click="wrc_identity('userForm')">确认信息</button>
      </div>
    </div>
    <el-dialog
      title="请确认您的活动信息和组别"
      :visible.sync = "confirmInfo"
      center
      class="dialog"
    >
      <div class="confirmInfoDialog">

        <el-form :model="userInfo">
          <el-form-item label="报名编号" label-width="80px">
            <el-input placeholder="请输入" v-model.trim="userInfo.wrcId" class="w90" readonly></el-input>
          </el-form-item>
          <el-form-item label="学校" label-width="80px">
            <el-input placeholder="请输入" v-model.trim="userInfo.schoolCnName" class="w90" readonly></el-input>
          </el-form-item>
          <el-form-item label="队伍" label-width="80px">
            <el-input placeholder="请输入" v-model.trim="userInfo.teamName" class="w90" readonly></el-input>
          </el-form-item>  
          <el-form-item label="姓名" label-width="80px" prop="userName" id="userName">
            <el-input placeholder="请输入" v-model.trim="userInfo.userName" class="w90" readonly></el-input>
            <p v-if="userInfo.accountName && (userInfo.accountName != userInfo.userName)" style="color: #ff7373; margin: 0">
              注意：账号在ICode平台上的姓名为：{{ userInfo.accountName }}<br/>
              请再次确认您登录了正确的ICode账号。
            </p>
          </el-form-item>
          <!-- <el-form-item label="年级" label-width="60px">
            <el-input placeholder="请输入" v-model.trim="userInfo.gradeName" class="w90" readonly></el-input>
          </el-form-item> -->
          <el-form-item label="组别" label-width="80px">
            <el-input placeholder="请输入" v-model.trim="userInfo.gameName" class="w90" readonly></el-input>
          </el-form-item>
          <el-form-item label="指导教师" label-width="80px">
            <el-input v-model.trim="userInfo.teacherName" class="w90" readonly></el-input>
          </el-form-item>    

        </el-form>
        <p>如果您的信息有误，请到世界机器人大赛报名平台修改，待审核通过后再重新报名！</p>

        <div class="btnlist">
          <button class="up" @click="submitMethod()">确认参赛信息无误</button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";
import Common from "@/utils/common";
import { errorInfo } from "@/utils/error";
import {IdentityCodeValid} from "@/utils/validation";
import '@/components/contest/assets/css/wrc.scss';
import { parseEventInfo } from '@/components/contest/template/event';

export default {
  props:['eventInfo'],
  data() {
    return {
      loginStep: 1,
      confirmInfo:false,
      gradeList: Common.gradeList(),
      userInfo: {
        grade:"",
        schoolCnName:"",
        md5Password: "",
        userName:"",
        userId:"",
        mobile:"",
        userAccount:"",
        gameId:"",
        isVip: 0,
        orgId: 0,
        accountName: null,
      },
      loading: false,
      // 登录表单
      userForm: {
        name: "",
        password: "",
        identity: "",
      },
      loginRules: {
        name: [
          { required: true, message: "帐号不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      identityRules: {
        identity: [
          { required: true, message: "请输入身份证件", trigger: "blur"},
          { min: 9, max: 18, message: "证件为9-18位长度", trigger: "blur"},
          { validator: IdentityCodeValid, trigger: "blur"},
        ],
        wrcId: [
          { required: true, message: "请输入报名编号", trigger: "blur"},
          { min: 5, max: 6, message: "报名编号为5位长度", trigger: "blur"},
        ],
        userName: [
          { required: true, message: "请输入选手姓名", trigger: "blur"},
        ],
      },
      
    };
  },

  methods: {


    getBgImg() {
      let url;
      if(!this.eventInfo.bgImg) {
        url = "https://c.icode.org.cn/statics/assets/backgrounds/std_bg_wrc.jpg"
      } else if(this.eventInfo.bgImg.startsWith("http")) {
        url = this.eventInfo.bgImg;
      } else {
        url = `https://c.icode.org.cn/statics/assets/backgrounds/std_bg_${this.eventInfo.bgImg}.jpg`
      }
      
      return { background: `url("${url}") center / cover no-repeat` }
    },
    // 按输入的关键词搜索学校
    querySearchAsync(queryString, cb) {
      if (queryString == null || queryString == "") {
        cb([]);
        return;
      }
      this.$http
        .getAxios("/mobile/querySchoolMsg?schoolName=" + queryString, {
          method: "post",
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            var schools = res.data;
            if (schools == null) {
              cb([]);
              return;
            }
            var results = queryString
              ? schools.filter(this.createStateFilter(queryString))
              : schools;
            cb(results);
          } else {
            cb([]);
          }
        });
    },
    // 学校名字替换
    changeSchool(e) {
      this.userInfo.schoolCnName = e.schoolCnName;
    },
    toSignup() {
      this.$router.push({
        path: "/"+ this.eventInfo.channel + "/signup",
      });
    },

    async getExistInfo() {
      try {
        let res = await this.$http.getAxios("/user/queryUserInfo");
        // code=0 -> 用户登录成功
        if (res.data.code == "0") {
          this.userInfo.accountSchool = res.data.data.schoolName;
          this.userInfo.accountName = res.data.data.firstName;
        } else {
          this.$notify.error({
            title: "无用户信息",
            message: "未找到用户信息，请先重新登录。" ,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 登录方法
    loginBehavior(userForm) {
      this.$refs[userForm].validate((valid) => {
        if (valid) {
          this.loading = true;
          sessionStorage.setItem("userAccount", this.userForm.name);
   
          this.$http.getAxios("/user/channel/userLogin", {
              // 初赛API
              method: "post",
              data: {
                email: this.userForm.name,
                password: md5(this.userForm.password),
                eventCode: this.eventInfo.eventCode,
              },
            }).then((res) => {
              const _res = res.data;
              this.loading = false;

              if (_res.code == "0") {
                this.$notify({
                  type: "success",
                  title: this.$t("Login_Successfuly"),
                  message: this.$t("Login_Successfuly"),
                });

                this.getUserInfo()

              // 如果开放报名，则读取用户信息
              } else if (_res.code == "120") {

                // 专属训练平台单独处理
                if(this.eventInfo.channel == "wrc_learn") {
                  this.$notify({
                    type: "error",
                    title: this.$t("Login_Successfuly"),
                    message: "您未开通专属训练平台，详情请联系各地区赛事负责人",
                  });
                  return;
                }

                this.loginStep = 2; // 确认身份信息
                this.$notify({
                  type: "success",
                  title: this.$t("Login_Successfuly"),
                  message: "请输入身份证件确认您的大赛报名信息",
                });

              } else {
                this.$notify({
                  type: "error",
                  title: this.$t("Sorry"),
                  message: errorInfo(_res),
                });
              }
            });

        } else {
          this.$notify({
            type: "error",
            title: "账号或密码未填写",
            message: "请填写完整的账号登录信息",
          });
        }
      });
    },

    // 学校名字过滤并替换
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.schoolCnName.toLowerCase().indexOf(queryString.toLowerCase()) >=
          0
        );
      };
    },
    tofogot(){
      window.open('https://home.icode.org.cn/forgotPwd', '_blank')
    },
    submitMethod(type) {
      if (
        this.userInfo.userName == "" ||
        this.userInfo.grade === "" ||
        this.userInfo.schoolCnName == "" ||
        this.userInfo.gameId == ""
      ) {
        this.$message.error("请完整输入报名信息");
        return;
      }
              
      this.$http.getAxios("/event/userSignUp", { 
					method: "post",
					data: {
						firstName: this.userInfo.userName,
						grade: this.userInfo.grade,
						gameId: this.userInfo.gameId,
						schoolCnName: this.userInfo.schoolCnName, // 单位名称
						eventCode: this.eventInfo.eventCode,
						wrcId: this.userInfo.wrcId, // 这里WRC专用
					},
				}).then((res) => {
					const _res = res.data;
					if(_res.code == "0") {
						sessionStorage.setItem(this.eventInfo.channel + "Login", this.userInfo.gameId);
						sessionStorage.setItem("mode", parseInt(this.userInfo.gameId / 10) % 10);
						sessionStorage.setItem("eventGameList", JSON.stringify(this.eventInfo.eventGames));

						this.$notify.success({
							title: "成功",
							message: "报名成功！",
						});
						setTimeout(() => {
							this.$router.push({
								path: "/" + this.eventInfo.channel + "/userIndex"
							});
						}, 500);
					} else if(_res.code == 1) {
						this.$notify.error({
							title: "您已经报过名啦！",
							message: "该账号已报过名了，请直接登录账号，进入比赛页面。",
						});
						setTimeout(() => {
							this.$router.push({
								path: "/login"
							});
						}, 1000);
					} else {
						this.$notify.error({
							title: this.$t("Error"),
							message: "报名失败!" + "错误信息：" + _res.msg + "错误码:" + _res.code,
						});
					}
				});
    },

    async getUserInfo() {
      let result = false;
      try {
        await this.$http
          .getAxios(`event/getEventUser`, {
            method: "get",
            params: {
              eventCode: this.eventInfo.eventCode, // 预选赛
              competeType: 0, // 此值决定是否决赛，值为0或其他则表示非决赛，1则为决赛
              // mode: 1
            },
          })
          .then((res) => {
            var res = res.data;

            // 用户登录信息缺失
            if (res.code == "5") {
              this.startGameShow = false;
              this.logOutShow = false;
              this.maskBox = true;

              // 如果用户未注册此活动
            } else if (res.code == "120") {
              this.$notify({
                type: "error",
                title: "未找到用户",
                message: "未找到活动用户",
              });
              // 读取用户信息并展示
              this.getExistInfo();
              this.confirmInfo = true;
            } else if (res.code == "0") {
              sessionStorage.setItem(this.eventInfo.channel + "Login", res.data.gameId);
              sessionStorage.setItem("mode", res.data.mode);
              sessionStorage.setItem("eventGameList", JSON.stringify(this.eventInfo.eventGames));
              this.$router.push({
                path: "/"+ this.eventInfo.channel + "/userIndex",
              });
            } else {
              // 只要出错就报对应的错误信息
              this.startGameShow = false;
              this.logOutShow = false;

              this.$notify.warning({
                title: "警告",
                message: res.msg,
              });
            }
          });
      } catch (e) {
        // 若未获取到登录ID信息，弹窗跳转
        this.$notify.error({
          title: this.$t("Sorry"),
          message: "信息：" + e,
        });
      }
      return result;
    },

    wrcIdentityBehavior(userForm) {
      this.$refs[userForm].validate((valid) => {
        if (valid) {
          localStorage.setItem("user_identity", this.userForm.identity)
          this.loading = true;

          this.$http.getAxios("/user/channel/wrcIdentity", {
            method: "get",
            params: {
              eventId: this.eventInfo.id,
              identity: this.loginStep == 2 ? this.userForm.identity : undefined,
              wrcId: this.loginStep == 3 ? this.userForm.wrcId : undefined,
              userName: this.loginStep == 3 ?this.userForm.userName : undefined,
            },
          }).then((res) => {
            this.loading = false;
            if(res.data && res.data.code == "0") {
              let data = res.data.data;

              this.confirmInfo = true; 

              this.userInfo.schoolCnName = data.registerSchoolName; // 特殊，使用registerSchoolName作为标准
              this.userInfo.teamName = data.teamName;
              this.userInfo.userName = data.userName;
              this.userInfo.grade = data.userGrade;
              // this.userInfo.gradeName = this.gradeList.find(g => g.id == this.userInfo.grade).name;
              let gameName = data.gameProgram + data.gameGroup;

              let game = this.eventInfo.eventGames.find(g => gameName.indexOf(g.aliasName) != -1);
              if(game == null) {
                gameName = gameName.replace("＋＋", "++"); // 报名平台使用符号不一致
                game = this.eventInfo.eventGames.find(g => gameName.indexOf(g.aliasName) != -1);
              }
              
              this.userInfo.gameId = game.gameId;
              this.userInfo.gameName = game.aliasName;
              this.userInfo.wrcId = data.wrcId;
              this.userInfo.teacherName = data.teacherName;

              this.getExistInfo();

            } else if (res.data && res.data.code == "144"){
              let msg = "该选手已确认过ICode账号，请直接登录该账号。如果非您的账号，请联系ICode工作人员解绑。\n"
                + (res.data.data.mobile ? ("绑定账号：" + res.data.data.mobile) : "" )
                + (res.data.data.account ? ("绑定账号：" + res.data.data.account) : "" );

              this.$notify({
                type: "error",
                title: "该身份证件已经绑定过",
                message: msg,
              });

            } else {
              this.$notify({
                type: "error",
                title: "未找到您的报名信息",
                message: "请检查：1.本场WRC赛事已结束报名（一般是赛前一周）, 2.输入的信息是否和报名信息是否完全一致，3.身份证错误可使用报名编号+姓名进行验证，4.尝试更换其他浏览器。",
              });  
            }
          })

        } else {
          this.$notify({
            type: "error",
            title: "不正确的身份证信息",
            message: "请填写正确的身份证信息，如报名时填写的身份证错误可使用报名编号+姓名进行验证",
          });
        }
      });
    },

    async getEventInfo(params) {
      try {
        await this.$http
          .getAxios(`event/getEvent`, {
            method: "get",
            params: params,
          })
          .then((res) => {
            const _res = res.data;

            if (_res.code == 0) {
              // this.eventInfo = _res.data;

              Object.assign(this.eventInfo, _res.data);
              parseEventInfo(this.eventInfo);

            } else {
              this.$notify.error({
                title: this.$t("Event_Not_Ready"),
                message: this.$t("Event_Not_Ready_Message"),
              });
            }

          });
      } catch (e) {
        console.log(e);
      }
    },
  },

  created() {
    this.userForm.identity = localStorage.getItem("user_identity") || "";
    this.login = this.$lodash.throttle(this.loginBehavior, 2000);
    this.wrc_identity = this.$lodash.throttle(this.wrcIdentityBehavior, 2000);

    let channel = "wrc_" + this.$route.params['channel'];
    
    if(channel != this.eventInfo.channel){
      this.getEventInfo({channel: channel});
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/contest/wrc/template/login.vue